






































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import FileStore from "@/types/settings/filestores/FileStore";
import settingsApi from "@/services/api.settings.service";

import { getPathForFileStore } from "./FileStoreSettings.vue";

@Component({
	model: {
		prop: "fileStore",
		event: "input"
	}
})
export default class FileStoreDeleteModal extends Vue {
	@Prop({ type: Object, default: null }) public fileStore: FileStore;

	private confirmation: string = "";

	/**
	 * Gets a value indicating whether or not the modal is open.
	 */
	private get isDeleteModalOpen(): boolean {
		return !!this.fileStore;
	}

	/**
	 * Gets a value indicating whether or not the delete button should be enabled.
	 */
	private get isDeleteButtonEnabled(): boolean {
		return this.confirmation.toLowerCase() == "delete";
	}

	/**
	 * Gets the path to display for the file store.
	 */
	private get fileStorePath(): string {
		return getPathForFileStore(this.fileStore);
	}

	/**
	 * Handler called when the modal is closed.
	 */
	@Emit("input")
	private onClose() {
		this.confirmation = "";
		return null;
	}

	/**
	 * Handler called when the user confirms they want to delete the file store.
	 */
	private async onDelete() {
		if (!this.isDeleteButtonEnabled) {
			return;
		}

		// Delete the file store
		await settingsApi.deleteFileStore(this.fileStore.fileStoreId);

		// Trigger a reload and close.
		this.$emit("reload-file-stores");
		this.onClose();
	}
}
